import { fromJS } from 'immutable'
import {
  DEPARTMENT_CREATE_REQUEST,
  DEPARTMENT_CREATE_SUCCESS,
  DEPARTMENT_CREATE_FAILURE,
  DEPARTMENT_CREATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case DEPARTMENT_CREATE_REQUEST:
      return state
        .set('isFetching', true)
    case DEPARTMENT_CREATE_SUCCESS:
      return state
        .set('departmentCreate', fromJS(action.payload.createdDepartment))
        .set('status', 200)
        .set('message', 'Created Successfully.')
        .set('isFetching', false)
    case DEPARTMENT_CREATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('departmentCreate', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case DEPARTMENT_CREATE_RESET:
      return state
        .delete('departmentCreate')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/department/department-create-reducer.js